import { NotesPanel } from "@components/shared/NotesPanel";
import { CampaignActivityTimeline } from "./CampaignActivityTimeline";
import { useCampaignDetail } from "./context";

export function ActivityTab() {
  const { campaign, refresh } = useCampaignDetail();

  return (
    <div className="space-y-6">
      <section>
        <h2 className="mb-3 text-sm font-semibold uppercase tracking-wide text-text-muted">
          Version history
        </h2>
        <CampaignActivityTimeline events={campaign.activityEvents ?? []} />
      </section>

      <section>
        <h2 className="mb-3 text-sm font-semibold uppercase tracking-wide text-text-muted">
          Notes
        </h2>
        <NotesPanel
          notableType="Campaign"
          notableId={campaign.id}
          notes={(campaign.attachedNotes ?? []) as never[]}
          onChanged={refresh}
          variant="list"
        />
      </section>
    </div>
  );
}
